<ng-container *ngIf="offerCategories$ | async as categories">
  <div *ngIf="categories.length > 0; else noItems">
    <div class="offer-category mb-lg-0 mb-4" *ngFor="let category of categories">
      <h2 class="category-name mt-lg-2 mt-0" [class.text-primary]="!isClub1901" [class.text-club1901-primary]="isClub1901">
        {{ category.categoryName }}
      </h2>

      <div class="row row-cols-1 row-cols-md-3">
        <div class="col mt-0 partner-offer-padding" *ngFor="let offer of category.offers">
          <div class="offer-card cursor-pointer" [routerLink]="['/brand/details', offer.OfferId]">
            <div class="offer-image-wrapper" [class.locked]="offer.Locked">
              <img [src]="offer.OfferImage | contentImage : '6'" alt="" class="offer-image" />

              <div class="company-logo-wrapper" *ngIf="offer.CompanyImage" [class.locked]="offer.Locked">
                <img [src]="offer.CompanyImage | contentImage : '6'" [alt]="offer.CompanyName" class="company-logo" />
              </div>

              <div *ngIf="offer.Locked" class="lock-badge">
                <span class="material-icons">lock</span>
              </div>
            </div>

            <div class="product-info">
              <p class="company-name mb-0">
                {{ offer.CompanyName }}
              </p>

              <p class="offer-title mb-0">
                {{ offer.OfferName }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #noItems>
    <div class="w-100 text-center no-items">
      <div class="no-results-placeholder-description card border p-3">
        {{ 'partner.offers.no.items.placeholder' | translate }}
      </div>
    </div>
  </ng-template>
</ng-container>
